import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateCoachProfileImage, deleteCoachProfileImage } from '../../../features/coach/coachProfileSlice';
import profileImage from '../../../assets/images/coachProfile.png';

export const CoachSidebar = ({
  activeView = 'dashboard'
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const { profile, profileImageLoading } = useSelector((state) => state.coachProfile);

  const storedCoach = JSON.parse(localStorage.getItem('coachProfile'));


  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(updateCoachProfileImage(file));
    }
  };

  const handleImageDelete = () => {
    if (window.confirm('Are you sure you want to delete your profile image?')) {
      dispatch(deleteCoachProfileImage());
    }
  };

  // const coachName = profile
  //   ? `${profile.firstName || ''} ${profile.lastName || ''}`.trim()
  //   : 'Loading...';

  // const jobTitle = profile?.jobTitle || 'HEAD COACH';
  // const organization = profile?.organization || profile?.school || 'ORGANIZATION';
  // const profileImageUrl = profile?.profileImage || profileImage;

  const coachName = profile ? `${profile.firstName || ''} ${profile.lastName || ''}`.trim() : (storedCoach?.name || 'Loading...');
  const jobTitle = profile?.jobTitle || storedCoach?.jobTitle || '-';
  const organization = profile?.school || storedCoach?.school || '-';
  const profileImageUrl = profile?.profileImage || storedCoach?.profileImage || profileImage;


  const getButtonClass = (view) => {
    return `block w-full py-3 px-4 rounded-lg font-medium text-left transition-all ${activeView === view
      ? 'bg-jp-accent/10 border border-jp-accent/50 border-l-4 border-l-jp-gold text-jp-accent-ink font-semibold'
      : 'bg-jp-section hover:bg-jp-line text-jp-muted hover:text-jp-ink'
      }`;
  };

  return (
    <div className="p-6 bg-jp-card border border-jp-line rounded-3xl shadow-sm">
      <div className="text-center mb-6">
        {/* Profile Image - Squared with rounded corners */}
        <div className="relative inline-block mb-4 group">
          <div className="w-40 h-40 rounded-xl bg-jp-section mx-auto overflow-hidden border-2 border-jp-line">
            <img
              src={profileImageUrl}
              alt="Profile"
              className="w-full h-full object-fill"
              onError={(e) => { e.target.src = profileImage; }}
            />
          </div>

          {/* Loading Overlay */}
          {profileImageLoading && (
            <div className="absolute inset-0 bg-black/70 rounded-xl flex items-center justify-center">
              <div className="w-10 h-10 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}

          {/* Hover Overlay with Upload/Delete Buttons */}
          {!profileImageLoading && (
            <div className="absolute inset-0 bg-black/60 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <div className="flex gap-2">
                <button
                  onClick={() => fileInputRef.current?.click()}
                  disabled={profileImageLoading}
                  className="p-2 bg-cyan-500 hover:bg-cyan-400 rounded-full transition-colors disabled:opacity-50"
                  title="Upload new image"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
                  </svg>
                </button>

                {profile?.profileImage && (
                  <button
                    onClick={handleImageDelete}
                    disabled={profileImageLoading}
                    className="p-2 bg-red-500 hover:bg-red-600 rounded-full transition-colors disabled:opacity-50"
                    title="Delete image"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Hidden File Input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="hidden"
        />

        {/* Name and Info */}
        <h3 className="text-jp-ink font-bold text-xl mb-1">{coachName}</h3>
        <p className="text-jp-muted text-sm font-semibold mb-1">{jobTitle.toUpperCase()}</p>
        <p className="text-jp-muted text-xs mb-6">ORGANIZATION: {organization.toUpperCase()}</p>
      </div>

      {/* Navigation Links */}
      <div className="space-y-2">
        <button
          onClick={() => handleNavigation('/coach/dashboard')}
          className={getButtonClass('dashboard')}
        >
          Profile
        </button>

        <button
          onClick={() => handleNavigation('/coach/teams')}
          className={getButtonClass('teams')}
        >
          Teams
        </button>

        <button
          onClick={() => handleNavigation('/coach/uncommitted-tracker')}
          className={getButtonClass('uncommittedTracker')}
        >
          Uncommitted Tracker
        </button>

        {/* <button
          onClick={() => handleNavigation('/coach/team-analysis')}
          className={getButtonClass('teamAnalysis')}
        >
          Team Analysis
        </button> */}

        <button
          onClick={() => handleNavigation('/coach/statistics')}
          className={getButtonClass('statistics')}
        >
          Statistics
        </button>

        <button
          onClick={() => handleNavigation('/coach/staff')}
          className={getButtonClass('staff')}
        >
          Assistant Coach
        </button>
      </div>
    </div>
  );
};

export default CoachSidebar;
